export const CHART_SPEC_VERSION = 2 as const;
export const CHART_SPEC_CONTRACT_HASH =
  '993eb91741b833a253df517f5734eaf839a80de3069bbe25b5f278cadda2ccc6';
